import React, { useEffect, useState } from 'react';
import { Collapse, IconButton } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import ColumnLabel from '@/main/components/common/columnLabel/columnLabel';

import { QuoteItemMappingPartViewReponse } from '@/main/models/response';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';

import DetailsMappingParts from './detailsMappingParts/detailsMappingParts';
import * as S from './styles';
import KogModalFadeComponent from '@/main/components/modal/ModalFadeComponent';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import Button from '@/main/components/shared/button/button';
import { quoteItemApi } from '@/main/api';
import { MapPartRequest } from '@/main/models/request';
import TooltipComponent from '@/main/components/shared/tooltip/tooltipComponent';

interface IRowMappingPartsProps {
  idRowToOpenCollapse: string;
  updateIdRowToOpenCollapse: (
    row: QuoteItemMappingPartViewReponse,
    isNextPart: boolean
  ) => void;
  mappingParts: QuoteItemMappingPartViewReponse;
  hasLastItem: boolean;
  removeItemGrid: (row: QuoteItemMappingPartViewReponse) => void;
}
function RowMappingParts({
  idRowToOpenCollapse,
  updateIdRowToOpenCollapse,
  mappingParts,
  hasLastItem,
  removeItemGrid
}: IRowMappingPartsProps) {
  const [expanded, setExpanded] = useState(false);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [
    partClicked,
    setPartClicked
  ] = useState<QuoteItemMappingPartViewReponse | null>(null);

  function handleClickRow(
    e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLDivElement>
  ) {
    e.stopPropagation();
    e.preventDefault();
    setExpanded(!expanded);
  }

  function handleDiscartRow(
    e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLDivElement>,
    row: QuoteItemMappingPartViewReponse
  ) {
    e.stopPropagation();
    e.preventDefault();

    setOpenModalConfirm(true);
    setPartClicked(row);
  }

  function updateIdRowToOpenCollapseCustom(
    row: QuoteItemMappingPartViewReponse,
    isNextPart: boolean
  ) {
    setExpanded(false);
    updateIdRowToOpenCollapse(row, isNextPart);
  }

  useEffect(() => {
    if (idRowToOpenCollapse === mappingParts.guidQuoteItem) {
      setExpanded(true);
    }
  }, [idRowToOpenCollapse]);

  const contentQuantity = `${mappingParts.quotesQuantity} ${getTranslateByKey(
    'information.times'
  )}`;
  return (
    <>
      <KogModalFadeComponent
        open={openModalConfirm}
        setOpen={setOpenModalConfirm}>
        <S.BoxModal>
          <S.TitleModal>
            {getTranslateByKey('information.areYouSureYouWantToDiscart')}
          </S.TitleModal>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '1rem'
            }}>
            <SecondaryButton
              type="button"
              onClick={() => {
                setOpenModalConfirm(false);
              }}
              id="id-discartmappigpart-button-no">
              {getTranslateByKey('information.no')}
            </SecondaryButton>

            <Button
              type="button"
              onClick={() => {
                if (!isNullUndefined(partClicked)) {
                  const request: MapPartRequest = {
                    insurerDescription: partClicked.partDescription,
                    partNumber: partClicked.partNumber
                  };

                  quoteItemApi.saveMappingPartDiscarted(request).then(() => {
                    setOpenModalConfirm(false);
                    removeItemGrid(partClicked);
                    setPartClicked(null);
                  });
                }
              }}
              id="id-discartmappigpart-button-yes">
              {getTranslateByKey('information.yes')}
            </Button>
          </div>
        </S.BoxModal>
      </KogModalFadeComponent>

      <S.ContainerRow $expanded={expanded}>
        <S.Container onClick={handleClickRow}>
          <ColumnLabel
            label={getTranslateByKey('information.partNumber')}
            content={
              <S.HyperLink
                onClick={e => {
                  e.stopPropagation();
                }}
                dangerouslySetInnerHTML={{
                  __html: mappingParts.partNumberSearchLink
                }}></S.HyperLink>
            }
          />
          <ColumnLabel
            label={getTranslateByKey('information.partDescription')}
            content={mappingParts.partDescription}
          />
          <ColumnLabel
            label={getTranslateByKey('information.quotesQuantity')}
            content={contentQuantity}
          />
          <S.AreaIcon>
            <TooltipComponent
              title={getTranslateByKey('information.discardMapping')}
              placement="top">
              <IconButton
                onClick={(
                  e:
                    | React.MouseEvent<HTMLButtonElement>
                    | React.MouseEvent<HTMLDivElement>
                ) => {
                  handleDiscartRow(e, mappingParts);
                }}
                id={`id-mappingParts-button-${mappingParts.partNumber}`}>
                <DeleteForeverIcon />
              </IconButton>
            </TooltipComponent>

            <IconButton
              onClick={handleClickRow}
              id={`id-mappingParts-button-${mappingParts.partNumber}`}>
              {expanded ? (
                <ExpandLess
                  aria-expanded={expanded}
                  aria-label={getTranslateByKey('information.showMore')}
                />
              ) : (
                <ExpandMore
                  aria-expanded={expanded}
                  aria-label={getTranslateByKey('information.showMore')}
                />
              )}
            </IconButton>
          </S.AreaIcon>
        </S.Container>
        <Collapse in={expanded} timeout="auto" mountOnEnter>
          <DetailsMappingParts
            expanded={expanded}
            hasLastItem={hasLastItem}
            mappingParts={mappingParts}
            updateIdRowToOpenCollapse={updateIdRowToOpenCollapseCustom}
          />
        </Collapse>
      </S.ContainerRow>
    </>
  );
}

export default RowMappingParts;
